import _ from './underscore.js';

// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
export default _.templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
};



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/templateSettings.js
// module id = 545
// module chunks = 106